/**
 * WordPress dependencies
 */
import { PluginDocumentSettingPanel } from '@safe-wordpress/edit-post';
import { registerPlugin } from '@safe-wordpress/plugins';

/**
 * External dependencies
 */
import { registerCoreExperiments } from '@nab/experiment-library';
import type { EntityKindName, ExperimentId, PostId } from '@nab/types';

/**
 * Internal dependencies
 */
import { PostAlternativeManagementBox } from '../post-alternative-management-box';

type Settings = {
	readonly experimentId: ExperimentId;
	readonly postBeingEdited: PostId;
	readonly type: EntityKindName;
};

export function initEditPostAlternativeBlockEditorSidebar(
	settings: Settings
): void {
	registerCoreExperiments();

	const { experimentId, postBeingEdited, type } = settings;

	registerPlugin( 'nelio-ab-testing', {
		icon: () => <></>,
		render: () => (
			<AlternativeEditingSidebar
				experimentId={ experimentId }
				postBeingEdited={ postBeingEdited }
				type={ type }
			/>
		),
	} );
}

// =======
// HELPERS
// =======

const AlternativeEditingSidebar = !! PluginDocumentSettingPanel
	? ( { experimentId, postBeingEdited, type }: Settings ) => (
			<PluginDocumentSettingPanel
				className="nab-alternative-editing-sidebar"
				title="Nelio A/B Testing"
			>
				<PostAlternativeManagementBox
					experimentId={ experimentId }
					postBeingEdited={ postBeingEdited }
					type={ type }
				/>
			</PluginDocumentSettingPanel>
	  )
	: () => null;
